import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const validateLink = (sessionId, requestType) => {
    return new Promise((resolve, reject) => {

        var fdd = new FormData;
        fdd.append('sessionId', sessionId);
        fdd.append('requestType', requestType);

        axios({
          method : "POST",
          url :  api_url + "/public/ValidateLink",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data"},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}